import React from 'react';
import PropTypes from 'prop-types';

/**
 * QualityAgentNotification
 * Muestra una notificación de calidad para un campo (ej: descripción GBP).
 * Props:
 * - status: 'good' | 'bad' (determina color y mensaje)
 * - message: string (mensaje a mostrar)
 * - onFix: función a ejecutar al hacer click en Fix
 * - onDismiss: función a ejecutar al hacer click en Dismiss
 * - suggestion: string (opcional, sugerencia para el fix)
 */
const QualityAgentNotification = ({
  status,
  message,
  onFix,
  onDismiss,
  suggestion,
  loadingFix,
  loadingDismiss,
  fixButtonText = 'Fix',
  isAnyOperationInProgress
}) => {
  const isGood = status === 'good';
  const isRecommended = status === 'recommended';
  return (
    <div
      className={`quality-agent-notification alert ${
        isRecommended
          ? 'alert-primary'
          : isGood
          ? 'alert-success'
          : 'alert-danger'
      } d-flex align-items-center justify-content-between`}
      role="alert"
      aria-live="polite"
      style={{
        margin: '10px 0',
        borderRadius: 6,
        maxWidth: 720,
        width: '100%'
      }}>
      <div>
        <span>{message}</span>
        {!isGood && suggestion && (
          <div style={{ fontSize: '0.95em', color: '#555', marginTop: 4 }}>
            <strong>Suggestion:</strong> {suggestion}
          </div>
        )}
      </div>
      <div className="ms-3 d-flex gap-2 align-items-center">
        {onFix && (
          <button
            className="btn btn-sm btn-success"
            onClick={onFix}
            aria-label="Fix description"
            tabIndex={0}
            disabled={
              loadingFix ||
              (isAnyOperationInProgress && isAnyOperationInProgress())
            }
            style={
              fixButtonText === 'Fix All'
                ? {
                    minWidth: '80px',
                    whiteSpace: 'nowrap',
                    padding: '0.375rem 0.75rem'
                  }
                : {}
            }>
            {loadingFix ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-label="Loading"
              />
            ) : (
              fixButtonText
            )}
          </button>
        )}
        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={onDismiss}
          aria-label="Dismiss notification"
          tabIndex={0}
          disabled={loadingDismiss}>
          {loadingDismiss ? (
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-label="Loading"
            />
          ) : (
            'Dismiss'
          )}
        </button>
      </div>
    </div>
  );
};

QualityAgentNotification.propTypes = {
  status: PropTypes.oneOf(['good', 'bad']).isRequired,
  message: PropTypes.string.isRequired,
  onFix: PropTypes.func,
  onDismiss: PropTypes.func.isRequired,
  suggestion: PropTypes.string,
  loadingFix: PropTypes.bool,
  loadingDismiss: PropTypes.bool,
  fixButtonText: PropTypes.string,
  isAnyOperationInProgress: PropTypes.func
};

export default QualityAgentNotification;
